<template>
    <div class="flex items-center">
        <a 
          @click.stop="params.colDef.CellRendererParams.openViewSidebar(params.data.invoice_id)"
        >
          {{ params.data.invoice_no }}
        </a>
    </div>
</template>

<script>
export default {
  name: 'InvoiceNumberCell'
}
</script>